import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as deTitles } from '../i18n/de.titles.json';
import { deliveryNoteCorrectionRoutes } from './delivery-note-correction.routes';
import {
  SOFTLINE_MODULE_WWS_DELIVERY_NOTE_CORRECTION,
  SOFTLINE_PERMISSION_WWS_DELIVERY_NOTE_CORRECTION,
} from './delivery-note-correction.shared';

// Legacy (monolith) entry — the NF shell loads src/federation/* instead.
// Two-export pattern: keep this and the federation entries in sync.
export const provideDeliveryNoteCorrectionModule = (): Array<
  Provider | EnvironmentProviders
> => [
  provideSoftAppsModule(
    {
      name: SOFTLINE_MODULE_WWS_DELIVERY_NOTE_CORRECTION,
      title: '#WWS_DELIVERY_NOTE_CORRECTION.TITLE',
      icon: 'fa-regular fa-file-pen',
      route: '/delivery-note-correction/overview',
      permission: SOFTLINE_PERMISSION_WWS_DELIVERY_NOTE_CORRECTION,
      group: getModuleGroupByName('Verkauf'),
    },
    withSoftAppsModuleRoutes({ app: deliveryNoteCorrectionRoutes }),
    withLazySoftAppsModuleTranslation({
      eager: { de: deTitles },
      lazy: { de: () => import('../i18n/de.json') },
    }),
    withSoftAppsModuleInfo({
      library: '@softapps/wws/delivery-note-correction',
      description: 'Lieferscheine suchen und Korrektur-Lieferscheine erstellen.',
    })
  ),
];
